module.exports = __webpack_public_path__ + "static/planning-side-26f2fa55c772b14b3bc948fc87c72d0e.png";